/** Ограничение сектора поиска адреса или приоритет поиска: параметры `locations[]`, `locations_boost[]` соответственно */
export const EAddrConstraintsTypes = Object.freeze({
    /** район */
    AREA: 'area',
    /** Ограничение населенного пункта */
    SETTLEMENT: 'settlement',
    /** Ограничение улицы */
    STREET: 'street',
    /** Ограничение по названию региона */
    REGION: 'region',
    /** город */
    CITY: 'city',
    /** Ограничение по стране */
    COUNTRY: 'country',
    /** Ограничение по ISO-коду региона */
    REGION_ISO_CODE: 'region_iso_code',
    /** Ограничение по ISO-коду региона страны */
    COUNTRY_ISO_CODE: 'country_iso_code',
    /** Ограничение по КЛАДР-коду */
    KLADR_ID: 'kladr_id',
    /** Ограничение по полному типу региона */
    GION_TYPE_FULL: 'gion_type_full',
    /** Ограничение по полному типу района в регионе */
    AREA_TYPE_FULL: 'area_type_full',
    /** Ограничение по полному типу города */
    CITY_TYPE_FULL: 'city_type_full',
    /** Ограничение по полному типу населенного пункта */
    SETTLEMENT_TYPE_FULL: 'settlement_type_full',
    /** Ограничение по полному типу улицы */
    STREET_TYPE_FULL: 'street_type_full',
    /** Ограничение по ФИАС-коду региона */
    REGION_FIAS_ID: 'region_fias_id',
    /** Ограничение по ФИАС-коду области */
    AREA_FIAS_ID: 'area_fias_id',
    /** Ограничение по ФИАС-коду города */
    CITY_FIAS_ID: 'city_fias_id',
    /** Ограничение по ФИАС-коду населенного пункта */
    SETTLEMENT_FIAS_ID: 'settlement_fias_id',
    /** Ограничение по ФИАС-коду улицы */
    STREET_FIAS_ID: 'street_fias_id',
});
